/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { TypeEntry } from '../model/typeEntry';
import { TypePaging } from '../model/typePaging';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class TypesApi extends BaseApi {
    getType(typeId) {
        throwIfNotDefined(typeId, 'typeId');
        const pathParams = {
            typeId
        };
        return this.get({
            path: '/types/{typeId}',
            pathParams,
            returnType: TypeEntry
        });
    }
    listTypes(opts) {
        const queryParams = {
            where: opts === null || opts === void 0 ? void 0 : opts.where,
            skipCount: opts === null || opts === void 0 ? void 0 : opts.skipCount,
            maxItems: opts === null || opts === void 0 ? void 0 : opts.maxItems,
            include: buildCollectionParam(opts === null || opts === void 0 ? void 0 : opts.include, 'csv')
        };
        return this.get({
            path: '/types',
            queryParams,
            returnType: TypePaging
        });
    }
}
